import type { Account } from '@modules-deprecated/app/accounts/types'
import type { TaxRate } from '@modules-deprecated/app/taxrates/types'

import type { ReviewEntryItem } from '../types/reviewEntryItem'
import type { ValidateReviewEntryPayload } from '../types/validateReviewEntryBill'
import { applyReviewEntryDraftToItem } from './applyReviewEntryDraftToItem'
import { buildValidateReviewEntryPayload } from './buildValidateReviewEntryPayload'
import { getReviewEntryCurrencyId } from './getReviewEntryCurrencyId'
import { getReviewEntryId } from './getReviewEntryId'
import { getReviewEntryLineDefaultValues } from './getReviewEntryLineDefaultValues'
import { getReviewEntryReceiptDate } from './getReviewEntryReceiptDate'
import { getReviewEntrySourceFingerprint } from './getReviewEntrySourceFingerprint'
import { parseReceiptDate } from './parseReceiptDate'
import { getReviewEntryDraft } from './reviewEntryDraftStorage'

interface BuildBulkValidateReviewEntryPayloadProps {
  accounts: Account[]
  entryIndex: number
  item: ReviewEntryItem
  organizationBaseCurrencyId: string | undefined
  organizationId: string
  purchaseTaxRates: TaxRate[]
  supplierId: string
}

export const buildBulkValidateReviewEntryPayload = ({
  accounts,
  entryIndex,
  item,
  organizationBaseCurrencyId,
  organizationId,
  purchaseTaxRates,
  supplierId,
}: BuildBulkValidateReviewEntryPayloadProps): ValidateReviewEntryPayload => {
  const draft = getReviewEntryDraft({
    entryId: getReviewEntryId(item, entryIndex),
    organizationId,
    sourceFingerprint: getReviewEntrySourceFingerprint(item),
  })
  const itemWithDraft = applyReviewEntryDraftToItem(item, entryIndex, organizationId)
  const resolvedSupplierId = draft?.supplier === null ? '' : draft?.supplier?.id || supplierId

  return buildValidateReviewEntryPayload({
    formValues: {
      currencyId: getReviewEntryCurrencyId(itemWithDraft.currencyId, organizationBaseCurrencyId),
      entryLines: (itemWithDraft.entryLines ?? []).map((line) =>
        getReviewEntryLineDefaultValues({ accounts, line, purchaseTaxRates }),
      ),
      invoiceNumber:
        draft?.invoiceNumber !== undefined
          ? draft.invoiceNumber.trim()
          : itemWithDraft.reference?.trim() || itemWithDraft.documentName,
      receiptDate: parseReceiptDate(getReviewEntryReceiptDate(itemWithDraft.entryDate, itemWithDraft.uploadedAt)),
      supplier: { id: resolvedSupplierId },
    },
    journalCode: itemWithDraft.journalCode,
  })
}
